query ContractShow($id: ID!) {
  contract(id: $id) {
    id
    organizationId
    title
    currency
    invoiceCurrency
    status
    dateFrom
    dateTo
    billingPeriodMonths
    paymentPeriodType
    paidPeriodDays
    note
    canceledAt
    items {
      type
      title
      amount {
        value
        currency
      }
    }
  }
}
